// Universal node registry — routes to the correct node definition registry
// based on the editor slot, so callers don't need to know which registry to use.

import type { NodeDefBase } from './nodeDefs.js';
import { RENDER_NODE_DEFS } from './renderNodeDefs.js';
import { getDataNodeDefs } from './dataNodeDefs.js';
import { EVENT_NODE_DEFS } from './eventNodeDefs.js';
import { QUERY_NODE_DEFS } from './queryNodeDefs.js';

export type RenderGraphKind = 'geometry' | 'material';
export type GraphRegistryKind = RenderGraphKind | 'data' | 'event' | 'query';

/** Returns the correct node definition registry for a given editor slot. */
export function nodeDefsForSlot(_slot: RenderGraphKind): Record<string, NodeDefBase> {
  return RENDER_NODE_DEFS as Record<string, NodeDefBase>;
}

export function nodeDefsForKind(kind: GraphRegistryKind): Record<string, NodeDefBase> {
  if (kind === 'data') return getDataNodeDefs();
  if (kind === 'event') return EVENT_NODE_DEFS;
  if (kind === 'query') return QUERY_NODE_DEFS;
  return nodeDefsForSlot(kind);
}
